import 'babel-polyfill';
import 'event-source-polyfill';
import 'angular';
import '@uirouter/angularjs';
import 'angular-material';
import 'angular-ui-tree';
import 'moment';
import 'lodash/cloneDeep';
import 'lodash/range';
import 'lodash/sortBy';
import 'lodash/merge';
import 'lodash/isString';
import 'lodash/round';
import 'lodash/sum';
import 'lodash/extend';
import 'angular-messages';
import 'angular-sanitize';
import 'angular-material-data-table';
import 'html2canvas';
import 'oidc-client';
import 'highcharts/js/highstock';
import 'highcharts/js/highcharts-more';
import 'highcharts/js/modules/no-data-to-display';
import 'ngmap';
import 'lucene-query-generator';
import 'angular-moment';
import './vendor-styles';



// WEBPACK FOOTER //
// ./vendor.js